import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import ParentFormDataContext from '../../contexts/ParentFormDataContext'
import './LanguageButton.css'
export interface ILanguageChanger {
    children?: any
    handleClick: (e: React.MouseEvent<HTMLButtonElement>) => void
    selectedLang?: number
}

const LanguageChanger: React.FC<ILanguageChanger> = ({
    children,
    handleClick,
    selectedLang
}) => {
    const { t, i18n, ready } = useTranslation()
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    let unselectedLanguage
    let selectedLanguage
    if (!(selectedLang === 0 || selectedLang === 1)) {
        unselectedLanguage = parentFormData.Language === 0 ? 'EN' : 'FR'
        selectedLanguage = parentFormData.Language === 0 ? 'FR' : 'EN'
    } else {
        unselectedLanguage = selectedLang === 0 ? 'EN' : 'FR'
        selectedLanguage = selectedLang === 0 ? 'FR' : 'EN'
    }
    if (!ready) {
        return <span>Loading...</span>
    }

    return (
        <div>
            <button className="btn" onClick={handleClick}>
                <p className="text-[10px] landingXs:text-lg">{selectedLanguage}</p>
            </button>
        </div>
    )
}

export default LanguageChanger
